/**
 * @generated SignedSource<<49a0a6f1f79105e081f2e9250d79995f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LandlordDirectoryPortal = "ON_THE_MARKET" | "RIGHTMOVE" | "ZOOPLA" | "%future added value";
export type LandlordDiscoveredBranchConsideration = "CLIENT_MONEY_PROTECTION_UNVERIFIED" | "FEES_NOT_PUBLISHED" | "LIMITED_GOOGLE_REVIEWS" | "%future added value";
export type LandlordDiscoveredBranchStrength = "CLIENT_MONEY_PROTECTION_VERIFIED" | "PUBLISHES_MANAGEMENT_FEE" | "STRONG_GOOGLE_REVIEWS" | "%future added value";
export type LandlordRedressScheme = "PROPERTY_REDRESS_SCHEME" | "THE_PROPERTY_OMBUDSMAN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DirectoryAgentPage_agent$data = {
  readonly address: string | null | undefined;
  readonly areas: ReadonlyArray<{
    readonly slug: string | null | undefined;
  }> | null | undefined;
  readonly companyNumber: string | null | undefined;
  readonly considerations: ReadonlyArray<LandlordDiscoveredBranchConsideration> | null | undefined;
  readonly email: string | null | undefined;
  readonly enrichedAt: string | null | undefined;
  readonly googleMapsUrl: string | null | undefined;
  readonly googleRating: number | null | undefined;
  readonly googleReviewCount: number | null | undefined;
  readonly hasClientMoneyProtection: boolean | null | undefined;
  readonly headOfLettingsName: string | null | undefined;
  readonly id: string;
  readonly logoUrl: string | null | undefined;
  readonly name: string | null | undefined;
  readonly openedYear: number | null | undefined;
  readonly phone: string | null | undefined;
  readonly portalListings: ReadonlyArray<{
    readonly listingCount: number | null | undefined;
    readonly portal: LandlordDirectoryPortal | null | undefined;
    readonly sourceUrl: string | null | undefined;
  }> | null | undefined;
  readonly redressScheme: LandlordRedressScheme | null | undefined;
  readonly services: ReadonlyArray<string> | null | undefined;
  readonly slug: string | null | undefined;
  readonly sources: {
    readonly clientMoneyProtection: ReadonlyArray<string> | null | undefined;
    readonly headOfLettings: ReadonlyArray<string> | null | undefined;
    readonly logo: ReadonlyArray<string> | null | undefined;
    readonly openedYear: ReadonlyArray<string> | null | undefined;
    readonly redressScheme: ReadonlyArray<string> | null | undefined;
    readonly services: ReadonlyArray<string> | null | undefined;
    readonly trustpilot: ReadonlyArray<string> | null | undefined;
  } | null | undefined;
  readonly strengths: ReadonlyArray<LandlordDiscoveredBranchStrength> | null | undefined;
  readonly trustpilotRating: number | null | undefined;
  readonly trustpilotReviewCount: number | null | undefined;
  readonly trustpilotUrl: string | null | undefined;
  readonly website: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryFeeBlock_agent">;
  readonly " $fragmentType": "DirectoryAgentPage_agent";
};
export type DirectoryAgentPage_agent$key = {
  readonly " $data"?: DirectoryAgentPage_agent$data;
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryAgentPage_agent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "openedYear",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "services",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "redressScheme",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DirectoryAgentPage_agent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "website",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headOfLettingsName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryPortalListing",
      "kind": "LinkedField",
      "name": "portalListings",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "portal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "listingCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleMapsUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleRating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleReviewCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "trustpilotUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "trustpilotRating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "trustpilotReviewCount",
      "storageKey": null
    },
    (v2/*:: as any*/),
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasClientMoneyProtection",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enrichedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryAreaReference",
      "kind": "LinkedField",
      "name": "areas",
      "plural": true,
      "selections": [
        (v0/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "strengths",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "considerations",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryAgentSources",
      "kind": "LinkedField",
      "name": "sources",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "trustpilot",
          "storageKey": null
        },
        (v2/*:: as any*/),
        (v3/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "clientMoneyProtection",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logo",
          "storageKey": null
        },
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headOfLettings",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DirectoryFeeBlock_agent"
    }
  ],
  "type": "LandlordDirectoryAgent",
  "abstractKey": null
};
})();

(node as any).hash = "fb03069df768dad60ad26fc05059ee1c";

export default node;
